import commandeRoutes from './routes'

/* @ngInject */
const commandeRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(commandeRoutes.index.path, {
      url: commandeRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'commandeCtrl',
      redirectTo: commandeRoutes.home.path,
    })
    .state(commandeRoutes.home.path, {
      url: commandeRoutes.home.url,
      template: require('./templates/home.html'),
    })
    .state(commandeRoutes.new.path, {
      url: commandeRoutes.new.url,
      template: require('./templates/new.html'),
    })
    .state(commandeRoutes.edit.path, {
      url: commandeRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(commandeRoutes.details.path, {
      url: commandeRoutes.details.url,
      template: require('./templates/details.html'),
    })
}

export default commandeRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/commande/commande.routes.js